import { useEffect, useCallback, useRef, useState } from 'react';

import { FormattedMessage, useIntl, defineMessages } from 'react-intl';

import { Link } from 'react-router-dom';

import { changeSetting } from 'mastodon/actions/settings';
import {
  fetchMostSuggestions,
  dismissSuggestion,
} from 'mastodon/actions/suggestions';
import { useAppDispatch, useAppSelector } from 'mastodon/store';
import { Card } from 'mastodon/features/explore/components/card';

const DISMISSIBLE_ID = 'home/follow-suggestions';

export const InlineFollowSuggestions: React.FC<{
  hidden?: boolean;
}> = ({ hidden }) => {
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const suggestions = useAppSelector((state) => state.suggestions.items);
  const isLoading = useAppSelector((state) => state.suggestions.isLoading);
  const dismissed = useAppSelector(
    (state) =>
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
      state.settings.getIn(['dismissed_banners', DISMISSIBLE_ID]) as boolean,
  );
  useEffect(() => {
    void dispatch(fetchMostSuggestions());
  }, [dispatch]);

  const handleDismiss = useCallback(() => {
    dispatch(changeSetting(['dismissed_banners', DISMISSIBLE_ID], true));
  }, [dispatch]);

  if (dismissed || (!isLoading && suggestions.length === 0)) {
    return null;
  }

  if (hidden) {
    return <div className='mobile-suggestions' />;
  }

  return (
    <div className='mobile-suggestions'>
      <div className='mobile-suggestions__header'>
        <h3 className='mobile-suggestions__title'>
          <FormattedMessage
            id='follow_suggestions.who_to_follow'
            defaultMessage='Who to follow'
          />
        </h3>

        <div className='mobile-suggestions__header__actions'>
          <button className='link-button' onClick={handleDismiss}>
            <FormattedMessage
              id='follow_suggestions.dismiss'
              defaultMessage="Don't show again"
            />
          </button>
          <Link to='/explore/suggestions' className='link-button'>
            <FormattedMessage
              id='follow_suggestions.view_all'
              defaultMessage='View all'
            />
          </Link>
        </div>
      </div>

      <div className='mobile-suggestions__container'>
        <div className='mobile-suggestions__scroll-area'>
          <div className='mobile-suggestions__list'>
            {suggestions.map((suggestion: any) => (
              <Card
                key={suggestion.account_id}
                id={suggestion.account_id}
                source={suggestion.sources[0]}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
